import type { SensorType } from '@eaphone/analyze/config';

export const datas: Partial<
  Record<
    SensorType,
    {
      title: string;
      content: Record<string, string>;
    }
  >
> = {
  '18': {
    title: '血压',
    content: {
      '血压是什么？':
        '血压是指血液在血管内流动时作用于单位面积血管壁的侧压力。心脏收缩时，从心室射入的血液对血管壁产生的侧压力为收缩压，心脏舒张末期，血液流动对血管壁的压力称为舒张压。',
      '为什么要测量血压？':
        '血压可以判断心脏功能与外周血管阻力，也是诊断疾病、观察病情变化与判断治疗效果的一项重要内容。',
    },
  },
  '22': {
    title: '血氧',
    content: {
      '血氧是什么？':
        '如厕指数是对您这次指标情况的得分汇总，用于综合评定您这次测量得出的如厕健康状态',
      '为什么要测量血氧？':
        '因为我们身体中的氧含量非常重要，正常的动脉血氧饱和度为 95-100%。当血氧饱和度产生下降，会产生各种疾病状态（如心力衰竭、慢性肺部疾病或睡眠呼吸暂停）。',
    },
  },
  resp_rate: {
    title: '呼吸率',
    content: {
      '呼吸率是什么？':
        '呼吸率为每分钟呼吸的次数，胸部的一次起伏就是一次呼吸，即一次吸气一次呼气。每分钟呼吸的次数也可以称为呼吸频率。',
      '为什么要测量呼吸率？':
        '呼吸减慢常见于代谢率降低、麻醉过量、休克以及明显颅内压增高等；呼吸增快主要见于肺炎、肺栓塞、胸膜炎、支气管哮喘、充血性心力衰竭、代谢亢进以及神经精神障碍等。',
    },
  },
};

export const titles: Partial<Record<SensorType, string>> = Object.fromEntries(
  Object.entries(datas).map(([key, { title }]) => [key, title]),
);
